export default {
    requiredObjectValues: value => {
        // returning the validation error
        for (let [key, val] of Object.entries(value)) {
            if (!val) {
                return {
                    errorMessageKey: "requiredField",
                    errorMessageKeyArgs: key,
                };
            }
        }
        return null;
    },
    requiredField: value => {
        // returning the validation error
        return value
            ? null
            : {
                  errorMessageKey: "requiredField",
              };
    },
};
